/* eslint-disable */ //todo temp
import Vue from 'vue';

Vue.mixin({
  methods: {
    //todo refactoring
    setTimeLastCall(id) {
      const date = new Date();
      const time = date.getHours() + ":" + date.getMinutes();
      let callNumber = 0;
      const callNumberCurrent = $("tr[data-id='" + id + "']").find('.call-n').html();

      if (!callNumberCurrent) {
        callNumber++
      } else {
        callNumber = parseInt(callNumberCurrent) + 1;
      }

      $("tr[data-id='" + id + "']").find('.call-n').html(callNumber);
      $("tr[data-id='" + id + "']").find('.call-last-time').html(time);
    },
    //todo refactoring
    updateleadDetails(data) {
      var currArr, newArr;
      //update info params values
      if (data.hasOwnProperty(ld_info)) {
        for (let prop in data[ld_info]) {
          leadDetails[ld_info][prop] = data[ld_info][prop];
        }
      }
      //update timeline
      if (data.hasOwnProperty(ld_timetable)) {
        currArr = leadDetails[ld_timetable];
        newArr = data[ld_timetable];
        leadDetails[ld_timetable] = newArr.concat(currArr);
      }
    },
    //todo refactoring
    getLeadViewPartials() {
      if ($('.sch-autoSearhContainer').is(":visible") || $('.sch-resContainer').is(":visible")) {
        clearResult();
        $('header').removeClass('scrollSearch');
      }
      document.title = leadDetails[ld_info][ld_login] + " " + leadDetails[ld_info][ld_firstname] + " " + leadDetails[ld_info][ld_lastname];
      showLeadViewInfo(leadDetails[ld_info]);
      showLeadForm(leadFormActive);
      showLeadTimeline(leadDetails[ld_timetable], leadTimelineActive);
    }
  }
});
